import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import BackButton from "../button/general/Back";
import { ReactNode } from "react";

export default function ViewOnePageHeading({
    title,
    description,
    Icon,
    buttons,
    route,
}: {
    title: string;
    description: string;
    Icon: LucideIcon;
    buttons?: ReactNode;
    route?: string;
}) {
    return (
        <CardHeader className="relative flex flex-col items-start border-b bg-slate-50/50 dark:bg-slate-800/50">
            <BackButton route={route} />
            <div className="flex w-full justify-between">
                <div className="flex items-center gap-3">
                    <div className="rounded-lg bg-primary/10 p-4">
                        <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                        <CardTitle className="text-3xl font-bold tracking-tight">
                            {title}
                        </CardTitle>
                        <CardDescription className="mt-1 text-sm text-muted-foreground">
                            {description}
                        </CardDescription>
                    </div>
                </div>
                <div className="flex items-center justify-center gap-3">
                    {buttons}
                </div>
            </div>
        </CardHeader>
    );
}
